import httpCreater from '@yld/yun-utils-http-creater'
import { Message } from 'element-ui'

const http = httpCreater({
  onFailrue: res => {
    // 网络超时处理
    if(res.msgCode && res.msgCode === 'FAIL_BIZ_GLOBAL_TIME_OUT_ERROR'){
      return Message({
        message: '网络异常，请求超时。请稍后再试',
        type: 'error',
        duration: 5 * 1000
      })
    } else if (res.msgCode && res.msgCode === 'FAIL_BIZ_GLOBAL_SYSTEM_ERROR' && res.msg && res.msg.indexOf('https') > -1){
      return Message({
        message:'系统异常，请稍后再试',
        type: 'error',
        duration: 5 * 1000
      })
    // }else if (res.msgCode && res.msgCode === 'FAIL_BIZ_GLOBAL_SYSTEM_ERROR'){
    //   return Message({
    //     message:res.msg,
    //     type: 'error',
    //     duration: 5 * 1000
    //   })
    } else {
      return Message({
        message: res.msg || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
    }
  }
})

export default http
